import { isEqual } from 'lodash';
import React, { useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

const SearchDropdownFilter = ({ type = "checkbox", title, inputPlaceholder, accessor, options = [], handleChange, handleSearch, isLoading, inputValue }) => {

    const [selectedItem, setSelectedItems] = useState(null);
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [show, setShow] = useState(false);

    const onInputChange = (e) => {

        if (e.target.value.trim()) setFilteredOptions(options.filter(x => x?.label?.toLowerCase()?.includes(e.target?.value?.toLowerCase())));
        else setFilteredOptions(options);

        if (handleSearch && typeof handleSearch == "function") handleSearch(e);
    };

    const handleSelectionChange = (id) => {

        setSelectedItems(id === selectedItem ? null : id);
        handleChange(id === selectedItem ? "" : id); // Pass the updated selection to the parent
        setShow(!show)
    };

    useEffect(() => {
        setFilteredOptions(options);
    }, [options]);

    return (
        <Dropdown show={show} onToggle={() => setShow(!show)}>
            <Dropdown.Toggle
                variant="transparent"
                className="border-0 d-flex align-items-center justify-content-center"
                id="dropdown-basic"
            >
                {title}
                <span className="icn ms-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="8"
                        viewBox="0 0 12 8"
                        fill="none"
                    >
                        <path
                            d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                            fill="black"
                        />
                    </svg>
                </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="px-2">
                <div className="top">
                    <div className="iconWithText position-relative">
                        <input
                            type="text"
                            placeholder={inputPlaceholder}
                            className="form-control"
                            style={{ height: 40 }}
                            onChange={onInputChange}
                        />
                        <span className="icn position-absolute" style={{ right: 5 }}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <path
                                    d="M14.2621 15.5737L9.27139 10.8843C8.81306 11.2627 8.28598 11.5589 7.69014 11.7728C7.09431 11.9867 6.47793 12.0936 5.841 12.0936C4.27426 12.0936 2.9483 11.5512 1.86312 10.4663C0.777942 9.38143 0.235352 8.05578 0.235352 6.48935C0.235352 4.92307 0.777789 3.59696 1.86266 2.51101C2.94754 1.42522 4.27319 0.882324 5.83962 0.882324C7.4059 0.882324 8.73201 1.42491 9.81796 2.51009C10.9037 3.59527 11.4466 4.92123 11.4466 6.48797C11.4466 7.14262 11.3368 7.76787 11.1171 8.3637C10.8973 8.95953 10.604 9.47776 10.2373 9.91837L15.228 14.6076L14.2621 15.5737ZM5.841 10.7188C7.02212 10.7188 8.02251 10.3089 8.84216 9.48914C9.66197 8.66948 10.0719 7.6691 10.0719 6.48797C10.0719 5.30685 9.66197 4.30646 8.84216 3.4868C8.02251 2.667 7.02212 2.25709 5.841 2.25709C4.65987 2.25709 3.65948 2.667 2.83983 3.4868C2.02003 4.30646 1.61012 5.30685 1.61012 6.48797C1.61012 7.6691 2.02003 8.66948 2.83983 9.48914C3.65948 10.3089 4.65987 10.7188 5.841 10.7188Z"
                                    fill="#1C1B1F"
                                />
                            </svg>
                        </span>
                    </div>
                </div>
                <ul style={{ maxHeight: "200px", overflowY: "scroll" }} className="list-unstyled ps-0 mb-0 pt-2">
                    {isLoading ? (
                        <li
                            className="d-flex align-items-center gap-10"
                        >
                            <label className="m-0 themeBlue w-100 d-flex justify-content-center">
                                Loading...
                            </label>
                        </li>
                    ) : filteredOptions.map((result) => (
                        <li
                            key={result.value}
                            className="d-flex align-items-start gap-10"
                            onClick={() => handleSelectionChange(result.value)}
                        >
                            <input
                                type={type}
                                className="form-check m-0"
                                checked={selectedItem === result.value}
                                // onChange={() => handleSelectionChange(result.value)}
                                onBlur={() => setFilteredOptions(options)}
                            />
                            <label htmlFor={result.value} className="m-0 themeBlue">
                                {result.label}
                            </label>
                        </li>
                    ))}
                </ul>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default SearchDropdownFilter;
